module.exports = __webpack_public_path__ + "img/tasks.b9a0abfe.svg";